import { render, staticRenderFns } from "./CompanionRatingCard.vue?vue&type=template&id=482a91e6&scoped=true&lang=pug&"
import script from "./CompanionRatingCard.vue?vue&type=script&lang=js&"
export * from "./CompanionRatingCard.vue?vue&type=script&lang=js&"
import style0 from "./CompanionRatingCard.vue?vue&type=style&index=0&id=482a91e6&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "482a91e6",
  null
  
)

export default component.exports